import { render, staticRenderFns } from "./TestBed.vue?vue&type=template&id=0b304115&scoped=true&"
import script from "./TestBed.vue?vue&type=script&lang=js&"
export * from "./TestBed.vue?vue&type=script&lang=js&"
import style0 from "./TestBed.vue?vue&type=style&index=0&id=0b304115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b304115",
  null
  
)

export default component.exports